import { CognitoGroup } from "../types"

export interface PageAccessPermission {
  path: string
  groups: CognitoGroup[]
}

// アクセス制限が必要なパスだけ定義する
export const PAGE_ACCESS_PERMISSION_LIST: PageAccessPermission[] = [
  {
    path: '/user/list',
    groups: ['supervisor'],
  },
]

export const hasPageAccessPermission = ({ path, groups }: PageAccessPermission): boolean => {
  // アクセス権限が定義されていないパスはアクセス制限なしとして全ての権限で叩けることとする
  return PAGE_ACCESS_PERMISSION_LIST
    .find(perm => perm.path === path)?.groups.some(accessableGroup => groups.includes(accessableGroup)) ?? true;
}
